import Cookies from "js-cookie";
import { downloadFromABlob } from "../utils/downloadFromABlob";
import { NotificationManager } from "react-notifications";
import { getFileNameFromDisposition } from "../utils/getFileNameFromDisposition";

export const downloadFileWithAuthorizationHeader = async (path = '', fileName = '') => {
  try {
    const isSignedS3Url = path.includes('X-Amz-Signature');
    const authenticationToken = Cookies.get("authentication_token_02");
    const optionsRequest = {
      method: 'GET',
      headers: isSignedS3Url ? {} : { 'Authorization': authenticationToken },
    }

    const response = await fetch(path, optionsRequest);

    const isACorrectResponse = response.status === 200;

    if (!isACorrectResponse) {
      NotificationManager.error('No se pudo obtener el archivo');
      return
    }

    let fileNameToBlob = fileName;
    const disposition = response.headers.get('Content-Disposition');
    const filenameFromDisposition = getFileNameFromDisposition(disposition);
    const doesFilenameFromDispositionExist = Boolean(filenameFromDisposition);

    if (doesFilenameFromDispositionExist) {
      fileNameToBlob = filenameFromDisposition;
    }

    const doesFilenameToBlobExist = Boolean(fileNameToBlob);

    if (!doesFilenameToBlobExist) {
      NotificationManager.error('No se pudo obtener el nombre del archivo');
      return
    }

    const fileBlob = await response.blob();
    downloadFromABlob(fileBlob, fileNameToBlob);

  } catch (error) {
    console.error('Error downloading file:', error);
    NotificationManager.error('No se pudo obtener el archivo');
  }
}
